module.exports = __webpack_public_path__ + "static/media/valor3.6cd80be3.png";